module.exports = {
	title: '首页'
};


// WEBPACK FOOTER //
// ./src/store/global/state.js